import { render, staticRenderFns } from "./changeSchool.vue?vue&type=template&id=70f9feb0&scoped=true"
import script from "./changeSchool.vue?vue&type=script&lang=js"
export * from "./changeSchool.vue?vue&type=script&lang=js"
import style0 from "./changeSchool.vue?vue&type=style&index=0&id=70f9feb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9feb0",
  null
  
)

export default component.exports